import { mapParamsBySchema } from '../../../../util';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import { M_FILE_CUSTOM_02_Schema } from './M_FILE_CUSTOM_02_Schema';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { handleQuerySuccess } from '../../../../Hooks/apis/useQuriesSuccess';

/** 교육 자료 조회 getTbmNewR8 */
export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(M_FILE_CUSTOM_02_Schema.mapper.search1);

  const query = useQuery({
    queryKey: ['File', 'getTbmNewR8', params],
    queryFn: () => apiRequest('post', Global.urls.ToolBoxMeeting.getTbmNewR8, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};
